/* eslint-disable @typescript-eslint/no-unsafe-return */
import Axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';

import { env } from '@/config/env';
import { handleLogout } from '@/features/auth';

function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  if (config.headers) {
    config.headers.Accept = 'application/json';
  }

  config.withCredentials = true;

  // Transform URLs based on environment configuration
  if (env.IS_OFFLINE && config.url?.startsWith('/')) {
    config.url = config.url.replace('/', '/omega-');
  }

  return config;
}

export const axios = Axios.create({
  baseURL: env.API_URL,
});

axios.interceptors.request.use(authRequestInterceptor);

axios.interceptors.response.use(
  response => {
    return response.data;
  },
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      handleLogout();
    }

    return Promise.reject(error);
  }
);
